import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../../AuthContext';
import Icon from '../assets/logo192.png';
import { toast } from 'react-toastify';
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import { FiKey, FiUser } from 'react-icons/fi';
import '../css/login.css';
import LoginImage from '../assets/sslg-elec.png'; // You'll need to add an image here

const LoginPage = () => {
  const [password, setPassword] = useState('');
  const [lrn, setLrn] = useState('');
  const [isLoggingIn, setIsLoggingIn] = useState(false);
  const [showLrnInput, setShowLrnInput] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showLrnPassword, setShowLrnPassword] = useState(false);
  const navigate = useNavigate();
  const { login } = useAuth();
  const envPassword = process.env.REACT_APP_LOGIN_PASSWORD;

  const handleSubmit = (e) => {
    e.preventDefault();
    if (password === envPassword) {
      setShowLrnInput(true);
    } else {
      toast.error('Incorrect password', {
        className: 'toast-error',
      });
    }
  };

  const handleLrnSubmit = (e) => {
    e.preventDefault();
    const name = process.env[`REACT_APP_LRN_${lrn}`];
    if (name) {
      setIsLoggingIn(true);
      toast.success('Login successful');
      setTimeout(() => {
        login(lrn, name);
        navigate('/home');
      }, 2000);
    } else {
      toast.error('Invalid LRN', {
        className: 'toast-error',
      });
    }
  };

  return (
    <div className="login-page-container">
      <div className="login-grid">
        <div className="login-form-container">
            <div className="login-card">
                <div className="text-center mb-8">
                    <img src={Icon} alt="Logo" className="w-24 h-auto mx-auto mb-4" />
                    <h1 className="login-title">SSLG Election Portal</h1>
                    <p className="text-slate-500 mt-2">Please sign in to continue</p>
                </div>

                {!showLrnInput ? (
                    <form onSubmit={handleSubmit} className="login-form">
                        <div className="relative">
                            <span className="absolute inset-y-0 left-0 flex items-center pl-3">
                                <FiKey className="h-5 w-5 text-slate-400" />
                            </span>
                            <input
                                type={showPassword ? 'text' : 'password'}
                                className="login-input pl-10 pr-10"
                                placeholder="Enter master password"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                required
                            />
                            <button
                                type="button"
                                className="absolute inset-y-0 right-0 flex items-center pr-3"
                                onClick={() => setShowPassword(!showPassword)}
                            >
                                {showPassword ? <FaEyeSlash className="h-5 w-5 text-slate-400" /> : <FaEye className="h-5 w-5 text-slate-400" />}
                            </button>
                        </div>
                        <button type="submit" className="login-button">
                            Continue
                        </button>
                    </form>
                ) : (
                    <form onSubmit={handleLrnSubmit} className="login-form">
                        <div className="relative">
                            <span className="absolute inset-y-0 left-0 flex items-center pl-3">
                                <FiUser className="h-5 w-5 text-slate-400" />
                            </span>
                            <input
                                type={showLrnPassword ? 'text' : 'password'}
                                className="login-input pl-10 pr-10"
                                placeholder="Enter your LRN"
                                value={lrn}
                                onChange={(e) => setLrn(e.target.value)}
                                required
                            />
                            <button
                                type="button"
                                className="absolute inset-y-0 right-0 flex items-center pr-3"
                                onClick={() => setShowLrnPassword(!showLrnPassword)}
                            >
                                {showLrnPassword ? <FaEyeSlash className="h-5 w-5 text-slate-400" /> : <FaEye className="h-5 w-5 text-slate-400" />}
                            </button>
                        </div>
                        <button type="submit" className="login-button">
                            Login
                        </button>
                    </form>
                )}

                <div className="text-center mt-6">
                    <Link to='/candidates' className="font-medium text-blue-600 hover:text-blue-500 text-sm">
                        View Candidates
                    </Link>
                    <br></br>
                    <Link to='/guidelines' className="font-medium text-blue-600 hover:text-blue-500 text-sm mt-2">
                        View Guidelines
                    </Link>
                </div>
            </div>
            <footer className="text-center text-slate-500 text-sm mt-8">
                <p>CDONHS-JH SSLG Election Portal v2.0.0 &copy; 2026 christian-av</p>
            </footer>
        </div>
        <div className="login-image-container">
            <img src={LoginImage} alt="CDONHS SSLG Election" className="login-image" />
        </div>
      </div>

        {isLoggingIn && (
            <div className="fixed inset-0 bg-slate-900 bg-opacity-80 flex flex-col items-center justify-center z-50 transition-opacity duration-300">
                <div className="flex items-center justify-center text-white">
                    <svg className="animate-spin -ml-1 mr-3 h-8 w-8 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                        <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                        <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                    </svg>
                    <span className="text-2xl font-['Poppins']">Logging In...</span>
                </div>
            </div>
        )}
    </div>
  );
};

export default LoginPage;
